import { useEffect, useState } from "react";
import NatureFavoritesPicker from "./NatureFavoritesPicker.jsx";
import { saveFavoriteNatureSoundIds } from "../../services/ai/memory/aiMemory.js";
import "./AuriaNatureOnboarding.css";

function AuriaNatureOnboarding({
  uid,
  naturalSounds = [],
  onComplete,
  onDismiss,
}) {
  const [step, setStep] = useState("intro");
  const [selectedIds, setSelectedIds] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = body.style.overflow;

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";

    return () => {
      html.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;
    };
  }, []);

  
  const complete = async () => {
    if (!uid || selectedIds.length !== 3 || isSaving) return;

    setIsSaving(true);
    setSaveError("");

    try {
      await saveFavoriteNatureSoundIds(uid, selectedIds);
      onComplete?.(selectedIds);
    } catch (error) {
      console.warn("Ambiances favorites non enregistrées.", error);
      setSaveError("Vos ambiances n’ont pas pu être enregistrées. Vous pouvez réessayer.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="auria-onboarding"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="auria-onboarding__stage"
      >
        {step === "intro" && (
          <div className="auria-onboarding__intro">
            <p className="auria-onboarding__eyebrow">
              Personnalisation
            </p>

            <h1>
              Choisissez vos ambiances préférées.
            </h1>

            <p>
              Sélectionnez trois sons naturels.
              Auria les utilisera en priorité
              dans vos prochaines séances.
            </p>

            <button
              type="button"
              className="auria-onboarding__cta"
              onClick={() => setStep("selection")}
            >
              Continuer
            </button>
            <button type="button" className="auria-onboarding__skip" onClick={() => onDismiss?.()}>Choisir plus tard</button>
          </div>
        )}

        {step === "selection" && (
          <div className="auria-onboarding__selection">
            <div className="auria-onboarding__head">
              <p className="auria-onboarding__eyebrow">
                Ambiances naturelles
              </p>

              <h1>
                Choisissez trois ambiances
              </h1>

              <p>
                Écoutez-les, puis sélectionnez
                celles que vous préférez.
              </p>
            </div>

            <NatureFavoritesPicker
              sounds={naturalSounds}
              selectedIds={selectedIds}
              onChange={setSelectedIds}
            />

            <button
              type="button"
              className="auria-onboarding__cta"
              onClick={complete}
              disabled={
                selectedIds.length !== 3 ||
                isSaving
              }
            >
              {isSaving
                ? "Enregistrement…"
                : "Valider mes choix"}
            </button>

            {saveError ? <p className="auria-onboarding__error" role="alert">{saveError}</p> : null}

            <button type="button" className="auria-onboarding__skip" onClick={() => onDismiss?.()} disabled={isSaving}>Choisir plus tard</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AuriaNatureOnboarding;